/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CommitIcon extends BaseIcon {
  getChildren = () => [<g><g><path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.68,6.15-5.31,5.6h0a1.1,1.1,0,0,1-1.61,0h0L3.33,9.2a1.26,1.26,0,0,1,0-1.7A1.11,1.11,0,0,1,5,7.5L6.56,9.2l4.51-4.74a1.1,1.1,0,0,1,1.61,0A1.25,1.25,0,0,1,12.68,6.15Z" fill={this.getColor()} /></g></g>]
  getViewBox = () => '0 0 16 16'
}
